import React from 'react'
import {Container,Row,Col} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom';

export default function NotFoundPage () {
  const { t } = useTranslation()

  return (
      <Container fluid>
      <Row>
          <Col xs={12} lg={6} className='d-flex flex-column py-4'>
              <div id="logotipo-auth" className='text-center text-md-start px-3 pb-5'><Link to="/"><img src="/images/logotipo-skill.svg" alt="Logotipo skillconnectED" /></Link></div>
              <Container className='p-0 py-5 p-md-5'>
                  <Row>
                      <Col className='px-5'>
                          <h1 className='my-5'>Error 404<br/>{t('global.pagenotfound')}</h1>
                          <Link to="/" className="btn btn-primary w-100 my-2">
                            {t('global.gotohome')}
                          </Link>
                      </Col>
                  </Row>
              </Container>
          </Col>

          <Col lg={6} className='d-none d-lg-block vh-100 m-0 position-relative'>
              <div className="video-background">
                  <video autoPlay loop muted>
                      <source src="/video/video-login.mp4" type="video/mp4" />
                      Tu navegador no soporta la reproducción de video.
                  </video>
              </div>
          </Col>
      </Row>
    </Container>
  )
}
